import React from 'react'
import PropTypes from 'prop-types'
import BaseIcon from '../../BaseIcon/BaseIcon'
import { ReactComponent as Component } from './SquareYouTube.svg'

const SquareYouTube = ({ className }) => {
	return <BaseIcon component={Component} className={className} viewBox="0 0 448 512" />
}

SquareYouTube.propTypes = {
	className: PropTypes.string,
}

export default SquareYouTube
